export const getTimeRemaining = (expiry, timeoutText) => {
  const thisDateTime = Math.floor(new Date().getTime() / 1000);
  const expiresAt = expiry;
  const diff = expiresAt - thisDateTime >= 0 ? expiresAt - thisDateTime : 0;
  const seconds = diff > 0 ? Math.floor(diff % 60) : 0;
  const minutes = diff > 0 ? Math.floor(diff / 60 % 60) : 0;
  const remaining = {
    timeString: "",
    // eslint-disable-next-line no-mixed-operators
    seconds: seconds <= 0 && minutes <= 0 ? 0 : seconds + minutes * 60
  };
  if (minutes >= 2) {
    remaining.timeString = `${minutes} mins`;
  } else if (!(seconds <= 0 && minutes <= 0)) {
    remaining.timeString = "< 2 mins";
  } else {
    remaining.timeString = timeoutText;
  }
  return remaining;
};